<script setup>
import BatchCreateComponent from "@/Components/Payments/BatchCreateComponent.vue";
import BatchesComponent from "@/Components/Payments/BatchesComponent.vue";
import {Permissions} from "@/Utils/Permissions";
</script>

<template>
  <v-row v-if="Permissions.checkPermissions(['payments.list-batches'])">
    <v-col cols="12">
      <BatchCreateComponent/>
    </v-col>
  </v-row>
  <v-row v-if="Permissions.checkPermissions(['payments.list-batches'])">
    <v-col cols="12">
      <BatchesComponent/>
    </v-col>
  </v-row>
</template>

<style scoped>

</style>